<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-19 11:52:01
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-10 17:57:30
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/goodItem/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div :class="['goods-item', noTenant, ksPlatform]">
		<el-skeleton style="width: 227px" :loading="lazyState" animated>
			<template slot="template">
				<el-skeleton-item variant="image" style="width: 227px; height: 227px; border-radius: 8px" />
				<div class="el-skeleton-content">
					<div class="flex flex-just-between">
						<el-skeleton-item style="width: 5%" class="mr-2" variant="text" />
						<el-skeleton-item style="width: 88%" class="mr-3" variant="text" />
						<el-skeleton-item style="width: 5%" variant="text" />
					</div>
					<el-skeleton-item variant="text" class="mt-4" style="width: 100%" />
					<div class="flex flex-just-between mt-20">
						<el-skeleton-item variant="text" style="width: 10%" />
						<el-skeleton-item variant="text" style="width: 30%" />
					</div>
					<div class="flex flex-just-between mt-4">
						<el-skeleton-item variant="text" style="width: 40%" />
					</div>
				</div>
			</template>
		</el-skeleton>
		<template v-if="!lazyState">
			<div class="goods-item-top">
				<div class="goods-images" :style="{ backgroundImage: 'url(' + info.productPic + ')' }"></div>
				<el-tooltip class="item" effect="dark" placement="top" :disabled="+tenantId !== +info.tenantId">
					<div slot="content"> 商品来源为自己，无法加入推广 </div>
					<div v-if="hasZsPartnerTag" :class="['promotion-mask', 'fz-12', +tenantId === +info.tenantId ? 'active-mask' : '']" @click="show(info)"
						>我要推广</div
					>
				</el-tooltip>
			</div>
			<div class="goods-item-bottom">
				<div class="goods-name-platform flex flex-just-between flex-align-center">
					<platform-icon style="flex-shrink: 0" class="mr-4" :platformId="info.platformId"></platform-icon>
					<el-tooltip placement="bottom" v-ak-tooltip-auto-show>
						<div slot="content">
							<span class="pointer">查看商品源链接</span>
						</div>
						<span @click="GoodsLink(info)" class="ml-4 line-ellipsis product-name fz-14 hover cursor-pointer" style="width: 165px">{{
							info.outerProductName | formatEmpty
						}}</span>
					</el-tooltip>
					<el-tooltip placement="top" :open-delay="300">
						<div slot="content">
							<span>商品ID</span>
							<span class="ml-4">{{ info.outerProductId || '-' }}</span>
							<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(info.outerProductId)"></i>
						</div>
						<div class="tag-lable radius-4 ml-4 font-h6-regular yx-color-text-regular cursor-pointer hover">ID</div>
					</el-tooltip>
				</div>
				<div class="goods-lable-content flex flex-align-center mt-8">
					<rd-text :value="merchantGoods ? '商品来源于商家，报名后可以推广给二级团长' : '商品来源于一级团长，报名后无法推广给其它团长'"
						><rd-tag class="mr-4 label-color" :value="merchantGoods ? '商家' : '团长'" :tag-type="'info'"></rd-tag
					></rd-text>
					<rd-text
						v-if="info.commissionType"
						:value="deadCommission ? '已设置好商品的服务费率和达人佣金率' : '可在总佣范围内设置报名时的服务费率和达人佣金率'"
					>
						<rd-tag class="mr-4 label-color" :value="deadCommission ? '固定佣金' : '灵活总佣'" :tag-type="'info'"></rd-tag>
					</rd-text>
					<rd-text
						v-if="+info.autoBindFlag"
						value="报名成功的商品将自动开启与商品来源的样品协同，在超佣团创建的样品订单可以协同至商家进行样品审核/样品发货/物流信息同步，可在“合作店铺”中管理商团协作"
					>
						<rd-tag class="mr-4 label-color" value="样品协同" :tag-type="'info'"></rd-tag>
					</rd-text>
					<rd-text v-if="+info.auditStatus" value="向商品来源发起推广审核，审核通过后自动报名并通过指定的招商活动计划">
						<rd-tag class="mr-4 label-color" value="人工审核" :tag-type="'info'"></rd-tag>
					</rd-text>
				</div>
				<div class="goods-price-service flex flex-align-center mt-12 flex-just-between">
					<div class="price fz-12">{{ info.salePrice | formatPrice }}</div>
					<div class="service fz-12" v-if="deadCommission"
						>服务费率 <span class="service-value">{{ info.serviceFeeRate | formatEmpty }}%</span>
					</div>
				</div>
				<div class="goods-earn-content flex flex-just-between flex-align-center mt-7">
					<div class="goods-earn-right fz-12 mt-8"
						><span>{{ deadCommission ? '达人佣金率' : '总佣金率' }}</span
						><span class="percent m-4 mr-4 fz-16">{{ deadCommission ? info.talentCommission : info.commissionRate }}</span
						>%</div
					>
				</div>
				<div class="goods-remain pb-12">
					<div class="goods-remain-top p-12">
						<div class="goods-remain-publicity fz-12 flex flex-just-between">
							<div class="remain-publicity-left"
								>普通佣金率 <span class="remain-percent">{{ info.baseCommissionRate | formatEmpty }}%</span>
							</div>
						</div>
						<div class="goods-remain-line mt-12"></div>
						<div class="goods-data-analysis pt-12">
							<div class="flex flex-align-center flex-just-between">
								<div class="analyhsis-title fz-12">近30天推广数据</div>
								<div v-if="$isKs(platformId)" class="order-num fz-12">{{ info.orderNum | formatEmpty | unit1Format }}</div>
							</div>
							<div v-if="$isDy(platformId)" class="promotion-data mt-8 flex flex-just-between">
								<div class="promotion-content">
									<div class="num fz-12">{{ info.orderNum | formatEmpty | unit1Format }}</div>
									<div class="promotion-name fz-12 mt-2">订单量</div>
								</div>
								<div class="promotion-content">
									<div class="num fz-12">{{ info.kolNum | formatEmpty | unit1Format }}</div>
									<div class="promotion-name fz-12 mt-2">推广达人</div>
								</div>
								<div class="promotion-content">
									<div class="num fz-12">{{ orderConversion | formatEmpty }}</div>
									<div class="promotion-name fz-12 mt-2">下单转化</div>
								</div>
							</div>
						</div>
						<div class="goods-experience mt-8 flex flex-just-between">
							<div class="goods-experience-left">
								<el-tooltip placement="top" :content="info.outerShopName" :open-delay="300" v-ak-tooltip-auto-show>
									<div class="line-ellipsis fz-12 experience-name font-bold">{{ info.outerShopName | formatEmpty }}</div>
								</el-tooltip>
							</div>
							<div class="goods-experience-right flex" v-if="$isDy(platformId)">
								<span class="experience-text fz-12">综合体验</span>
								<span class="experience-active ml-4 fz-12 font-bold">{{ info.outerShopScore | formatEmpty }}</span>
							</div>
						</div>
						<template v-if="!merchantGoods">
							<div class="goods-experience-line mt-12 mb-12"></div>
							<div class="goods-commander">
								<div class="goods-commander-top flex flex-align-center">
									<span class="goods-commander-name fz-12">来自团长：</span>
									<el-tooltip placement="top" :content="info.institutionName" :open-delay="300" v-ak-tooltip-auto-show>
										<div class="ml-4 line-ellipsis fz-12 goods-commander-text fz-12">{{ info.institutionName | formatEmpty }}</div>
									</el-tooltip>
								</div>
								<div class="goods-promotion flex flex-align-center">
									<span class="fz-12 promotion-left">推广至：</span>
									<span class="fz-12 promotion-timer">{{ info.promotionEndTime | formatEmpty }}</span>
								</div>
							</div>
						</template>
						<div class="goods-btn-content flex flex-just-between mt-12">
							<div v-if="info.handCard" class="view-btn font-h6-regular cursor-pointer" @click="onSeehandCard(info)">查看手卡</div>
							<div :class="['view-btn', 'cursor-pointer', 'fz-12', !info.handCard ? 'flex-1' : '']" @click="showPopup(info)">{{
								merchantGoods ? '联系商家' : '联系团长'
							}}</div>
						</div>
					</div>
				</div>
			</div>
			<promote-goods-drawer ref="promoteGoodsDrawer" />
			<handCard-dialog ref="handCardDialog" :has-replace-hand-card="false"></handCard-dialog>
		</template>
	</div>
</template>
<script>
import { copy } from '@/utils/common';
import { mapGetters } from 'vuex';
import { PLATFORM_DY } from '@/utils/dataMap';
import promoteGoodsDrawer from '../promoteGoodsDrawer/index.vue';
import { formatPercent } from '@/filters/index';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
export default {
	components: {
		promoteGoodsDrawer,
		handCardDialog,
	},
	props: {
		info: {
			type: [Object, Number],
			default: () => {},
		},
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
		lazyState: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters(['hasZsPartnerTag']),
		deadCommission() {
			return +this.info.commissionType === +newDataMap.SHOP_MANAGE.DEAD_COMMISSION.value;
		},
		merchantGoods() {
			return +this.info.appType === +newDataMap.SHOP_MANAGE.MERCHANDISE_GOODS.value;
		},
		orderConversion({ info }) {
			let percent = '';
			if (+info.orderNum && +info.viewNum) {
				percent = formatPercent(+info.orderNum / +info.viewNum);
			}
			return percent;
		},
		noTenant({ merchantGoods, lazyState }) {
			return !lazyState && !merchantGoods ? '' : 'no-tenant';
		},
		ksPlatform({ noTenant }) {
			let className = '';
			if (this.$isKs(this.platformId)) {
				className = noTenant ? 'ks-no-tenant' : 'ks-tenant';
			}
			return className;
		},
	},
	data() {
		return {
			tenantId: this.$store.state.vuex_tenantId,
		};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
		showPopup({ mobile }) {
			const title = this.merchantGoods ? '联系商家' : '联系团长';
			this.$modal({
				title,
				content: `手机号：${mobile}`,
				size: 'small',
				btns: [
					{
						type: 'primary',
						text: '复制号码',
						key: 'confirm',
					},
				],
			}).then(res => {
				if (res.key == 'confirm') {
					this.handleCopy(mobile);
					res.done();
				} else {
					res.done();
				}
			});
		},
		show(item) {
			if (+item.tenantId === +this.tenantId) {
				return;
			}
			this.$refs.promoteGoodsDrawer.show(item, this.platformId);
		},
		GoodsLink({ productUrl: link }) {
			var a = document.createElement('a');
			a.setAttribute('href', link);
			a.setAttribute('target', '_blank');
			a.setAttribute('id', 'startTelMedicine');
			// 防止反复添加
			if (document.getElementById('startTelMedicine')) {
				document.body.removeChild(document.getElementById('startTelMedicine'));
			}
			document.body.appendChild(a);
			a.click();
		},
		onSeehandCard(item) {
			this.$refs.handCardDialog['seeHandCard']({ product_id: item.productId, product_name: item.outerProductName });
		},
	},
};
</script>
<style lang="less" scoped>
.el-skeleton-content {
	padding: 8px 10px 12px 8px;
}
.goods-item {
	box-sizing: border-box;
	width: 227px;
	border-radius: 8px;
	height: 349px;
	overflow: hidden;
	background: @color-gy1;
	box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
	transition: all 0.2s ease-in-out;
	.goods-item-top {
		position: relative;
		width: 227px;
		height: 227px;
		cursor: pointer;
		.goods-images {
			border-radius: 8px;
			width: 227px;
			height: 227px;
			background-size: cover;
		}
		.promotion-mask {
			opacity: 0;
			display: flex;
			position: absolute;
			transition-delay: 0.3s;
			width: 100%;
			height: 32px;
			border-radius: 0px 0px 8px 8px;
			background: rgba(112, 82, 255, 0.96);
			left: 0px;
			bottom: 0px;
			align-items: center;
			justify-content: center;
			color: @color-gy1;
			transition: 0.5s linear;
		}
	}
	.goods-item-bottom {
		position: relative;
		padding: 8px 9px 0px 8px;
		border-radius: 8px;
		background: @color-gy1;
		.tag-lable {
			padding: 0 3px;
			position: relative;
			color: @color-regular;
			top: -1px;
			height: 17px;
			border-radius: 3px;
			background-color: @color-gy3;
			margin-left: 4px;
		}
		.product-name {
			color: @color-regular;
		}
		.goods-lable {
			height: 20px;
			line-height: 22px;
			padding: 0 2px 0 2px;
			border-radius: 3px;
			border: 1px solid @color-gy5;
			color: @color-regular;
		}
		.goods-price-service {
			line-height: 20px;
		}
		.price {
			font-family: 'Barlow-Bold';
			line-height: 20px;
		}
		.service {
			color: @color-gy8;
			line-height: 20px;
			font-family: 'Barlow-Bold';
		}
		.service-value {
			color: @color-gy9;
		}
		.goods-earn-left {
			.goods-earn-lable {
				width: 16px;
				height: 16px;
				border-radius: 2px;
				text-align: center;
				line-height: 17px;
				color: @color-r4;
				background: rgba(254, 54, 101, 0.06);
			}
			.earn-price {
				font-family: 'Barlow-Bold';
			}
		}
		.goods-earn-right {
			border-radius: 2px;
			padding: 0 2px 0 2px;
			height: 20px;
			line-height: 18px;
			background: rgba(254, 54, 101, 0.06);
			color: @color-r4;
			.percent {
				font-family: 'Barlow-Bold';
			}
		}
		.goods-earn-content {
			position: relative;
			z-index: 3;
			background: @color-gy1;
			box-shadow: 7px 0px 0px 0px @color-gy1, -7px 0px 0px 0px @color-gy1;
		}
		.goods-remain {
			opacity: 0;
			position: absolute;
			width: 100%;
			height: 0;
			left: 0;
			transition: all 0.3s ease-in-out;
			background: @color-gy1;
			.goods-remain-publicity {
				height: 20px;
				line-height: 20px;
				line-height: 21px;
				.remain-publicity-left {
					background: @background-color-base;
					padding: 0 2px 0 2px;
					height: 20px;
					line-height: 22px;
					border-radius: 2px;
					color: @color-gy7;
					.remain-percent {
						color: @color-gy7;
						font-family: 'Barlow-Bold-Bold';
					}
				}
				.remain-publicity-right {
					line-height: 20px;
					color: @color-gy7;
				}
			}
			.goods-remain-line {
				width: 100%;
				height: 1px;
				background: @color-gy3;
			}
			.analyhsis-title {
				color: @color-gy7;
				line-height: 12px;
			}
			.promotion-data {
				padding: 12px 12px 12px 18px;
				background: @color-gy2;
				border-radius: 8px;
				.num {
					text-align: center;
					color: @color-gy9;
					line-height: 16px;
					font-family: 'Barlow-SemiBold';
				}
				.promotion {
					text-align: center;
				}
				.promotion-name {
					text-align: center;
					color: @color-gy7;
				}
			}
			.goods-experience-left {
				display: flex;
				align-items: center;
				.experience-img {
					width: 20px;
					height: 20px;
					border-radius: 50%;
				}
				.experience-name {
					width: 94px;
				}
			}
			.goods-experience-right {
				.experience-text {
					color: @color-gy7;
				}
				.experience-active {
					color: @color-gy9;
					font-family: 'Barlow-Medium';
				}
			}
			.goods-experience-line {
				width: 100%;
				height: 1px;
				background: @color-gy3;
			}
			.goods-commander {
				.goods-commander-name {
					min-width: 60px;
					color: @color-gy7;
					line-height: 20px;
				}
				.goods-commander-text {
					width: 142px;
					color: @color-gy8;
				}
			}
			.promotion-left {
				color: @color-gy7;
				line-height: 20px;
			}
			.promotion-timer {
				margin-left: 15px;
				color: @color-gy8;
				line-height: 20px;
			}
			.view-btn {
				width: 95px;
				height: 28px;
				text-align: center;
				line-height: 28px;
				border-radius: 4px;
				background: @color-gy1;
				border: 1px solid @color-gy5;
			}
		}
	}
	.active-mask {
		background: #9b86ff !important;
		color: rgba(255, 255, 255, 0.5);
	}
}
.goods-item:hover {
	transition-delay: 0.1;
	overflow: visible;
	.promotion-mask {
		opacity: 1;
	}
	.goods-remain {
		border-radius: 0 0 8px 8px;
		transition-delay: 0.1s;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		z-index: 2;
		opacity: 1;
		height: 270px;
	}
}
.order-num {
	font-family: 'Barlow-Bold';
	color: @color-gy9;
}
.no-tenant:hover {
	.goods-remain {
		border-radius: 0 0 8px 8px;
		transition-delay: 0.1s;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		z-index: 2;
		opacity: 1;
		height: 210px !important;
	}
}
.ks-tenant:hover {
	.goods-remain {
		border-radius: 0 0 8px 8px;
		transition-delay: 0.1s;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		z-index: 2;
		opacity: 1;
		height: 210px !important;
	}
}
.ks-no-tenant:hover {
	.goods-remain {
		border-radius: 0 0 8px 8px;
		transition-delay: 0.1s;
		box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
		z-index: 2;
		opacity: 1;
		height: 145px !important;
	}
}
.label-color {
	/deep/ .info {
		color: @color-gy8;
	}
}
</style>
